
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/mobile/perform-cross-chain-atomic-swaps",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/mobile/perform-cross-chain-atomic-swaps/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/mobile/perform-cross-chain-atomic-swaps"])
      });
    }
  